import push from '../../utils/routing';
import { showBackButtonForContent } from '@core/constants/backButtonNavigation';

export const getMaterialsPath = (spaceId: string) =>
  `/dashboard/${spaceId}/journey/materials`;

export default (
    spaceId: string,
    materialSectionId?: string | null,
    queryParams?: Record<string, string>
  ) =>
  () => {
    // Get the base url
    const baseUrl = materialSectionId
      ? `${getMaterialsPath(spaceId)}/${materialSectionId}`
      : getMaterialsPath(spaceId);

    // QUICK FIX : This logic ensures that we maintain proper back navigation behavior.This will check if there are any query parameters to be appended.
    // If not, it will check the existing URL for any "from" parameters to maintain navigation context.
    const { showBackbutton, queryParams: backParams } =
      showBackButtonForContent();
    const finalQuery = queryParams ?? (showBackbutton ? backParams : undefined);

    // Append query params if available
    push({
      pathname: baseUrl,
      ...(finalQuery ? { query: finalQuery } : {}),
    });
  };
